import * as Flux from 'dg-web-shared/lib/Flux';

export const flux = new Flux.Store();
